import QT2GForm from "./QT2GForm";
import MiniQ2Form from "./MiniQ2Form";
import { useEffect, useState } from "react";

const ManagerMQTTForm = ({ item, model }) => {
    const [value, setValue] = useState("");

    useEffect(() => {
        setValue(model);
    }, [model])

    const renderFormByModel = () => {
        switch (value) {
            case "QT-2G":
                return <QT2GForm item={item} />;
            case "MQ2-4G":
                return <MiniQ2Form item={item} />;
            default:
                return <></>;
        }
    };


    return renderFormByModel();

}
export default ManagerMQTTForm;